import {AfterViewInit, Component, Inject, ViewEncapsulation} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import { BASE_URL, API_VERSION } from '../shared/base.url';
import { LoopBackConfig } from '../shared/sdk/lb.config';
import { TransferState } from '../../modules/transfer-state/transfer-state';
import {CityUtils} from "./../../../common/utils/cityutils";
import {ProfessionCategoriesUtils} from "./../../../common/utils/professioncategoriesutils";
import {
  AM_PROFILES, AM_FOOD_PLANS, AM_TOP_CITY_MIN_POPULATION, AM_SPECIAL_PROFESSIONS,
  AM_SLIDER_DEFAULTS, AM_DEFAULTS, AM_PROFESSIONS
} from "../shared/map.defaults";
import {Observable} from "rxjs";
import {MapUrlUtils} from "../../../common/utils/mapurlutils";
import {AffordabilityUtils} from "../../../common/utils/affordabilityutils";
import * as _ from "lodash";
import {CensusTractsTilesUtils} from "../../../common/utils/censustractstilesutils";

declare var L: any;
declare var d3: any;

@Component({
  templateUrl: './cost-of-living.component.html',
  styleUrls: [ './cost-of-living.component.scss', './page-slide.scss', './leaflet.scss', './nouislider.scss' ],
  selector: 'costOfLivingComponent',
  encapsulation: ViewEncapsulation.None,
})

export class CostOfLivingComponent implements AfterViewInit {

  public city: Observable<any>;
  public profile: any = {
    id: "",
    name: "",
    firstProfession: "",
    secondProfession: "",
    householdMembers: [],
    houseRentArea: 2000,
    foodPlan: "",
    description: ""
  };

  public slider: any;
  public topCities: any[];
  public specialProfessions: any = AM_SPECIAL_PROFESSIONS;
  public professions: any[] = AM_PROFESSIONS;
  public foodPlans: any[] = AM_FOOD_PLANS;
  public profiles: any = AM_PROFILES;
  public censusTract: Observable<any>;
  public professionTypeToSelect: string = 'first';
  public youAgeRange: number[] = [];
  public ageRange: number[] = [];

  private dataFromUrl: any;
  private map: any;
  private layers: any = {tracts : {}};
  private features: any = [];
  private baseUrl: string;

  constructor(@Inject('isBrowser') protected isBrowser: boolean,
              protected route: ActivatedRoute,
              protected cache: TransferState,
              protected cityUtils: CityUtils,
              protected mapUrlUtils: MapUrlUtils,
              protected professionCategoriesUtils: ProfessionCategoriesUtils,
              protected affordabilityUtils: AffordabilityUtils,
              protected tilesUtils: CensusTractsTilesUtils) {

    LoopBackConfig.setBaseURL(BASE_URL);
    LoopBackConfig.setApiVersion(API_VERSION);

    let topCitiesKey = "topCities";
    let topCities = this.cache.get(topCitiesKey);

    for (let i = 1; i <= 65; i ++) {
      this.ageRange.push(i);
      if (i >= 20) {
        this.youAgeRange.push(i);
      }
    }

    if (topCities == null) {
      this.cityUtils.loadCitiesByMinPopulation(AM_TOP_CITY_MIN_POPULATION).subscribe(data => {
        this.topCities = data;
        this.cache.set(topCitiesKey, data);
      });
    } else {
      this.topCities = topCities;
    }

    this.slider = {
      min: AM_SLIDER_DEFAULTS.min,
      max: AM_SLIDER_DEFAULTS.max,
      value: AM_SLIDER_DEFAULTS.value
    }

    this.route.params.subscribe(params => {

      let cityKey = params['city'] + ':' + params['state'];
      let city = this.cache.get(cityKey);

      if (city == null) {
        this.city = this.cityUtils.loadBySeoIdAndState(params['city'], params['state']);
        this.city.subscribe(data => {
          this.cache.set(cityKey, data);
        });
      } else {
        this.city = Observable.of(city);
      }
    });

    if (this.isBrowser) {

      this.dataFromUrl = this.mapUrlUtils.resolveDataFromUrl(window.location);
      this.resolveProfile(this.dataFromUrl);
      this.slider.value = this.profile.houseRentArea ? this.profile.houseRentArea : this.slider.value;
      this.baseUrl = this.resolveBaseUrl();
    }
  }

  ngAfterViewInit(): void {

    if (this.isBrowser) {

      this.city.subscribe(city => {

        let center = this.resolveMapPosition(city, this.dataFromUrl);
        this.map = L.map('map', {
          center: new L.LatLng(center.lat, center.lng),
          zoom: center.zoom,
          minZoom: 9,
          maxZoom: 16,
          scrollWheelZoom: false,
          attributionControl: false,
          touchZoom: true
        });

        this.map.on("zoomstart", (ev) => {
          this.layers.tracts.g.style('display', 'none');
          this.layers.tracts.g.selectAll('path').remove();
        });

        this.map.on("zoomend", (ev) => {
          this.refreshMap();
          this.updateUrl();
        });

        this.map.on("dragstart", (ev) => {
          this.layers.tracts.g.selectAll("path").on('click', null);
        });

        this.map.on("dragend", (ev) => {
          this.refreshMap();
          this.updateUrl();
        });

        this.map.on("moveend", (ev) => {
          this.updateUrl();
        });

        L.tileLayer("https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png").addTo(this.map);

        this.affordabilityUtils.loadIndicators().subscribe(() => {
          this.layers.tracts.svg = d3.select('.leaflet-overlay-pane').append('svg');
          this.layers.tracts.g = this.layers.tracts.svg.append('g').attr('class', 'leaflet-zoom-hide tracts-layer');
          this.refreshMap();
        });

      });

      $(document).on("click", ".dropdown-professions .option-group-name", ev => {

        ev.stopPropagation();

        let element = $(ev.target);
        let parent_dropdown = element.parents('div.dropdown-menu');
        let parent_option_group = element.parents('li.option-group');
        let option_group_list = element.next('li').find('ul');

        if (option_group_list.is(':visible')) {
          option_group_list.fadeOut(500);
        } else {
          parent_dropdown.find('ul.option-group-list').css('display', 'none');
          option_group_list.fadeIn(1000);
          parent_dropdown.animate({scrollTop: parent_option_group.get(0).offsetTop}, '1000');
        }

      });

      $(document).on("click", ".dropdown-professions .custom-income, " +
        ".delete-member-button, " +
        ".household-members-control .dropdown-menu," +
        ".add-member-btn",
        (ev) => {
          ev.stopPropagation();
        });

      $(document).on("mousemove", "#map", this.updateTooltipPosition);
    }
  }

  protected isCustomProfileData(data: any): boolean {

    return data.firstProfession || data.firstProfessionIncome || data.secondProfession || data.secondProfessionIncome
      || data.householdMembers || data.houseRentArea || data.foodPlan;
  }

  protected buildProfile(prototype: any): any {

    return {
      id: prototype.id,
      name: prototype.name,
      firstProfession: this.affordabilityUtils.findProfession(this.professions, prototype.firstProfession),
      firstProfessionIncome: prototype.firstProfessionIncome,
      secondProfession: this.affordabilityUtils.findProfession(this.professions, prototype.secondProfession),
      secondProfessionIncome: prototype.secondProfessionIncome,
      householdMembers: prototype.householdMembers,
      houseRentArea: prototype.houseRentArea,
      foodPlan: _.find(AM_FOOD_PLANS, function (o) {return o.code === prototype.foodPlan;}),
      bedroomsMin: prototype.bedroomsMin ? prototype.bedroomsMin : 0,
      bedroomsMax: prototype.bedroomsMax ? prototype.bedroomsMax : 5
    };
  }

  protected resolveProfile = function(data) {

    let prototype: any;

    if (data.profileId && AM_PROFILES[data.profileId]) {
      prototype = AM_PROFILES[data.profileId];
    } else if (this.isCustomProfileData(data)) {
      prototype = data;
      prototype.id = "custom_household";
      prototype.name = "Custom Household";
    } else {
      prototype = AM_PROFILES[AM_DEFAULTS.profileId];
    }

    this.profile = this.buildProfile(prototype);
  };

  protected resolveMapPosition(city, data): any {
    return  {
      lat: data.lat ? data.lat : city.point.coordinates[1],
      lng: data.lng ? data.lng : city.point.coordinates[0],
      zoom: data.zoom ? data.zoom : 11
    };
  };

  protected getMapBounds() {
    let bounds = this.map.getBounds();
    return {nw: bounds.getNorthWest(), se: bounds.getSouthEast()};
  }

  protected renderGeoData(layer): void {

    let self = this;
    let transform = d3.geoTransform({point: projectPoint});
    let path = d3.geoPath().projection(transform);

    layer.transform = transform;
    layer.path = path;

    var ids = [];
    var faturesNoDuplicates = [];
    for (var i = 0; i < this.features.length; i++) {

      if (ids.indexOf(this.features[i].properties.id) == -1) {
        ids.push(this.features[i].properties.id);
        faturesNoDuplicates.push(this.features[i]);
      }
    }

    //first of all, remove outside poligons
    layer.g.selectAll("path")
      .filter(function(d) {
        return (ids.indexOf(d.properties.id) == -1);
      }).remove();

    let poligons = layer.g.selectAll("path")
      .data(faturesNoDuplicates.filter(function(d) {
        return d.properties.rental_price > 0;
      }), function (d) {
        return d.properties.id;
      }).enter()
      .append("path")
      .attr('id', function (d) {
        return d.properties.id;
      })
      .attr('class', 'tract')
      .style('fill', 'white')
      .style('fill-opacity', 0).on('mouseover', (data) => {

      let selectedFeature = $('.tract-actived');

      /*let parent = selectedFeature.parents("g");

      if (!!selectedFeature) {
        d3.select(poligons).moveToFront();
        d3.select(selectedFeature.get(0)).moveToFront();
      } else {
        d3.select(poligons).moveToFront();
      }*/

      this.showTooltip(data);
    }).on('mouseout',  () => {
      this.hideTooltip();
    }).on('click', function (data) {

        poligons.attr('class', 'tract');
        $(this).attr('class', 'tract-actived');
        self.onFeatureClick(data);
    });

    layer.g.selectAll("path")
      .transition()
      .duration(1000)
      .style('fill-opacity', 0.6)
      .style('fill', (d) => {
        return this.getFeatureFillColor(d.properties.moneyLeft);
      });


    this.fitSVGLayer(layer);
    layer.g.style('display', 'block');

    function projectPoint(x, y) {
      var point = self.map.latLngToLayerPoint(new L.LatLng(y, x));
      this.stream.point(point.x, point.y);
    }
  }

  protected onFeatureClick(data) {

    this.map.panTo(L.latLng(data.properties.lat, data.properties.lng));
    if (this.map.getZoom() < 11) {
      setTimeout(() => { this.map.setZoom(11); }, 500);
    }
  }

  protected getFeatureFillColor(moneyLeft) {

    if (moneyLeft == 0) {
      return '#fff';
    } else {

      let moneyLeftAbs = Math.abs(moneyLeft);
      let index = 0;

      for (let i = 0; i < AM_DEFAULTS.intervals.length; i ++) {

        let intervalLimit = AM_DEFAULTS.intervals[i];

        if (moneyLeftAbs <= intervalLimit) {
          index = i;
          break;
        }

        if (i == AM_DEFAULTS.intervals.length - 1) {
          index = i;
        }
      }

      return moneyLeft > 0 ? AM_DEFAULTS.legendColors[index + 4] : AM_DEFAULTS.legendColors[3 - index];
    }
  }

  protected refreshMap() {

    let bounds = this.getMapBounds();
    let zoom = this.map.getZoom();

    this.tilesUtils.loadCensusTracts(zoom, bounds.nw, bounds.se).map(features => {
      this.features = features;
      return this.affordabilityUtils.calculateAffordability(this.profile, this.features).subscribe(() => {
        this.renderGeoData(this.layers.tracts);
      });
    }).subscribe(() => {
      this.censusTract = this.findNearestCensusTract(this.map.getCenter().lat, this.map.getCenter().lng);
      this.profile.description = this.getProfileDescription();
    });

  }

  protected fitSVGLayer(layer) {

    let bounds = layer.path.bounds(this.createBoundsFeature(this.map.getBounds()));
    let topLeft = bounds[0];
    let bottomRight = bounds[1];

    layer.svg.attr('width', bottomRight[0] - topLeft[0])
      .attr('height', bottomRight[1] - topLeft[1])
      .style('left', topLeft[0] + 'px')
      .style('top', topLeft[1] + 'px');

    layer.g.attr('transform', 'translate(' + -topLeft[0] + ','
      + -topLeft[1] + ')');

    layer.g.selectAll("path").attr("d", layer.path);
  }

  protected createBoundsFeature(bounds) {

    let padding = 0.5;
    let ne = bounds.getNorthEast();
    let sw = bounds.getSouthWest();
    let nw = {lat: ne.lat, lng: sw.lng};
    let se = {lat: sw.lat, lng: ne.lng};

    return  {
      "type" : "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [nw.lng - padding, nw.lat + padding],
          [ne.lng + padding, ne.lat + padding],
          [se.lng + padding, se.lat - padding],
          [sw.lng - padding, sw.lat - padding],
          [nw.lng - padding, nw.lat + padding]]]
      }
    };
  }

  protected findNearestCensusTract(lat, lng): Observable<any> {

    let censusTract: any = null;
    let minDistance: any = -1;

    for (let feature of this.features) {

      let censusTractCenter: any[] = [feature.properties.lat, feature.properties.lng];
      let distance:number = this.calculateDistance([lat, lng], censusTractCenter);

      if (minDistance == -1 || minDistance > distance) {
        minDistance = distance;
        censusTract = feature;
      }
    }

    return Observable.of(censusTract);
  };

  protected findNearestCity() {

    let lat = this.map.getCenter.lat;
    let lng = this.map.getCenter.lng;
    let city: any = null;
    let minDistance: number = -1;

    for (let topCity of this.topCities) {

      let cityCenter: any = [topCity.point.coordinates[1], topCity.point.coordinates[0]];
      let distance: number = this.calculateDistance([lat, lng], cityCenter);

      if (minDistance == -1 || minDistance > distance) {
        minDistance = distance;
        city = topCity;
      }
    }

    this.city = Observable.of(city);
  };

  protected calculateDistance(point1, point2) {

    let lat1 = parseFloat(point1[0]);
    let lon1 = parseFloat(point1[1]);
    let lat2 = parseFloat(point2[0]);
    let lon2 = parseFloat(point2[1]);

    let R = 6371; // km
    let dLat = this.toRad(lat2-lat1);
    let dLon = this.toRad(lon2-lon1);
    let dlat1 = this.toRad(lat1);
    let dlat2 = this.toRad(lat2);

    let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(dlat1) * Math.cos(dlat2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    let d = R * c;

    return d;
  }

  protected toRad(number): number {
    return number * Math.PI / 180;
  };

  protected resolveBaseUrl() {

    let path = window.location.pathname.replace(/\/$/, '');

    path = path.substring(0, path.lastIndexOf("/"));
    path = path.substring(0, path.lastIndexOf("/") + 1);

    return window.location.protocol + '//' + window.location.host + path;
  }

  protected showTooltip(feature) {

    let tooltipBox = $('.map-tooltip-box');
    let tractCode = feature.properties.id.substring(5);
    tractCode = tractCode.substring(0, 4) + '.' + tractCode.substring(4);

    tooltipBox.find('.region-name').html(feature.properties.name);
    tooltipBox.find('.census-tract-name').html('Census tract: ' + tractCode);

    let description =  tooltipBox.find('.description');
    description.removeClass('positive');
    description.removeClass('negative');

    if (feature.properties.moneyLeft > 0) {

      description.addClass('positive');
      description.html('Money left after expenses living here: ' + '$' + this.addCommas(Math.abs(Math.round(feature.properties.moneyLeft))) + '/yr');

    } else {

      description.addClass('negative');
      description.html('Additional income needed to live here: ' + '$' + this.addCommas(Math.abs(Math.round(feature.properties.moneyLeft))) + '/yr');
    }

    tooltipBox.css('display', 'block');
  }

  protected hideTooltip() {

    let tooltipBox = $('.map-tooltip-box');
    tooltipBox.css('display', 'none');

    tooltipBox.find('.region-name').html('');
    tooltipBox.find('.description').html('');
    tooltipBox.find('.census-tract-name').html('');
  }

  protected updateTooltipPosition(ev) {

    let tooltipBox = $('.map-tooltip-box');
    let cursorOffset: number = 25;

    if (tooltipBox.is(":visible")) {

      let header = $('.map-header');
      let body = $('.leaflet-map');

      let headerHeight = header.outerHeight();
      let bodyWidth = body.outerWidth();
      let tooltipBoxHeight = tooltipBox.outerHeight();
      let tooltipBoxWidth = tooltipBox.outerWidth();

      let left = ev.pageX - body.offset().left - (tooltipBoxWidth / 2);
      let top = ev.pageY - body.offset().top;

      if (top - headerHeight < tooltipBoxHeight + cursorOffset) {

        top = top + cursorOffset;

      } else {

        top = top - cursorOffset - tooltipBoxHeight;
      }

      if (left < 10) {

        left = 10;

      } else if (left + tooltipBoxWidth + 10 > bodyWidth) {

        left = bodyWidth - tooltipBoxWidth - 10;
      }

      tooltipBox.css('top', top);
      tooltipBox.css('left', left);
    }
  }

  protected addCommas(n) {

    let sign: number = 1;

    if (n < 0) {
      sign = -1;
      n = n * -1;
    }

    var rx=  /(\d+)(\d{3})/;

    return String(n).replace(/^\d+/, (w) => {

      while (rx.test(w)) {
        w = w.replace(rx, '$1,$2');
      }

      return sign == -1 ?  '-' + w : w;
    });
  }

  protected getProfileDescription() {

    let description: string = '';

    if (AM_PROFILES[this.profile.id]) {
      description = AM_PROFILES[this.profile.id].description;
    } else {

      let total_members = this.profile.householdMembers.length;
      let firstIncome = this.profile.firstProfessionIncome;
      let secondIncome = this.profile.secondProfessionIncome;
      let first_profession_selected = false;

      description = 'Average income minus cost of living expenses ';
      let occupation_text = '';
      let spouse_occupation_text = '';
      let family_text = '';
      let food_plan_text = this.profile.foodPlan.name.toLowerCase();

      if (this.profile.firstProfession.code != null && this.profile.firstProfession.code.substring(0, 2) != '00') {

        occupation_text = ' for ' + this.profile.firstProfession.name.toLowerCase() + ' ';
        first_profession_selected = true;
      }

      if (this.profile.secondProfession.code != null && this.profile.secondProfession.code.substring(0, 2) != '00') {

        if (!first_profession_selected || first_profession_selected && firstIncome < secondIncome) {

          occupation_text = ' for ' + this.profile.secondProfession.name.toLowerCase() + ' ';
        }
      }

      if (this.profile.secondProfession.code != null &&
        this.profile.secondProfession.code != AM_SPECIAL_PROFESSIONS.AVERAGE_INCOME.code &&
        this.profile.secondProfession.code != AM_SPECIAL_PROFESSIONS.STAY_AT_HOME.code) {

        spouse_occupation_text = ', including spouse\'s income';
      }

      if (total_members > 1) {
        family_text = '  for a ' + total_members + '-member family';
      }

      if (this.profile.firstProfession.code == AM_SPECIAL_PROFESSIONS.MINIMUM_WAGE.code &&
        (secondIncome == 0 || this.profile.secondProfession.code == AM_SPECIAL_PROFESSIONS.MINIMUM_WAGE.code)) {

        description = 'Full-time minimum wage minus cost of living expenses ';
      }

      description += occupation_text + 'renting a ' + this.profile.houseRentArea + ' sq.ft. house under a '
        + food_plan_text + ' budget' + family_text + spouse_occupation_text + '.';
    }

    return description;
  }

  public updateUrl() {

    this.city.subscribe((city: any) => {

      let data: any = {
        lat: this.map.getCenter().lat,
        lng: this.map.getCenter().lng,
        zoom: this.map.getZoom(),
        firstProfession: this.profile.firstProfession.code,
        firstProfessionIncome: this.profile.firstProfessionIncome,
        secondProfession: this.profile.secondProfession.code,
        secondProfessionIncome: this.profile.secondProfessionIncome,
        householdMembers: this.profile.householdMembers,
        houseRentArea: this.profile.houseRentArea,
        foodPlan: this.profile.foodPlan,
        bedroomsMin: this.profile.bedroomsMin,
        bedroomsMax: this.profile.bedroomsMax,
        state: city.state.code,
        city:  city.seo_id
      };

      if (!!AM_PROFILES[this.profile.id]) {
        data.profileId = this.profile.id;
      }

      let url = this.mapUrlUtils.resolveUrlFromData(this.baseUrl, data);

      if (this.mapUrlUtils.supportHistoryApi()) {
        history.replaceState({}, '', url.toString());
      } else {
        window.location.hash = url.hash();
      }
    });

  }

  public setCity(topCity): void {
    this.layers.tracts.g.style('display', 'none');
    this.city = Observable.of(topCity);
    this.city.subscribe(city => {
      this.map.panTo(L.latLng(city.point.coordinates[1], city.point.coordinates[0]));
      this.refreshMap();
      this.updateUrl();
    });
  }

  public setProfile(profileId: string): void {

    if (profileId != "custom_household") {
      this.profile = this.buildProfile(AM_PROFILES[profileId]);
    } else {
      this.profile.id = profileId;
      this.profile.name = "Custom Household";
    }

    this.slider.value = this.profile.houseRentArea ? this.profile.houseRentArea : this.slider.value;
    this.refreshMap();
    this.updateUrl();
  }

  public toggleLocationScreen(): void {

  }

  public toggleProfileScreen(): void {

  }

  public setProfession(profession: object) {
    if (this.professionTypeToSelect == 'first') {
      this.setFirstProfession(profession);
    } else {
      this.setSecondProfession(profession);
    }
  }

  public setFirstProfession(profession: object): void {
    this.profile.firstProfession = profession;
    this.refreshMap();
    this.updateUrl();
  }

  public setSecondProfession(profession: object): void {
    this.profile.secondProfession = profession;
    this.refreshMap();
    this.updateUrl();
  }

  public setCustomIncome(event: any, profession: any): void {

    let element = $(event.target);
    let parentContainer = element.parents('.custom-income');
    let formControl = parentContainer.find('.form-inline')
    let incomeInput = parentContainer.find('.custom-income-input');
    let incomeError = parentContainer.find('.custom-income-error');
    let incomeValue = parseFloat(incomeInput.val().replace(/[^0-9.]/g, ''));

    formControl.removeClass('has-error');
    incomeError.html('');

    if (!isNaN(incomeValue)) {

      if (profession.code == AM_SPECIAL_PROFESSIONS.FIRST_CUSTOM_INCOME.code) {
        this.profile.firstProfession = profession;
        this.profile.firstProfessionIncome = incomeValue;
        $('.first-profession').removeClass('open');
      } else {
        this.profile.secondProfession = profession;
        this.profile.secondProfessionIncome = incomeValue;
        $('.second-profession').removeClass('open');
      }

      this.refreshMap();
      this.updateUrl();

    } else {
      formControl.addClass('has-error');
      incomeError.html('Invalid value');
    }
  }

  public sliderEnd() {
    this.refreshMap();
    this.updateUrl();
  }

  public setSliderTooltip(value) {
    this.slider.value = value;
  }

  public setFoodPlan(plan: any) {
    this.profile.foodPlan = plan;
    this.refreshMap();
    this.updateUrl();
  }

  public addMember(gender: string): void {
    this.profile.householdMembers.push({id: new Date().getTime(), age: "21", gender: gender ? gender: "M"});
    this.refreshMap();
    this.updateUrl();
  }

  public updateMember() {
    this.refreshMap();
    this.updateUrl();
  }

  public removeMember(member: any): void {

    let index = _.findIndex(this.profile.householdMembers, function(o) {
      return o.id === member.id;
    });

    if (index !== -1) {
      this.profile.householdMembers.splice(index, 1);
      this.refreshMap();
      this.updateUrl();
    }
  }

  public toggleScreen(selector, position) {
    let dataScreen = $(selector);
    if (dataScreen.hasClass("center")) {
      dataScreen.removeClass("center");
      dataScreen.addClass("transition");
      dataScreen.addClass(position);
    } else {
      dataScreen.removeClass(position);
      dataScreen.addClass("transition center");
    }
  }

  public toggleProfessionCategory(event) {

    let element = $(event.currentTarget);
    let professions = element.find('.option-group-list');

    if (professions.is(':visible')) {
      professions.fadeOut('fast');
    } else {
      $('.option-group-list:visible').css('display', 'none');
      professions.fadeIn();
      $('.map-settings .professions').animate({scrollTop: element.get(0).offsetTop}, '1200');
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/cost-of-living/cost-of-living.component.ts